<script setup lang="ts">
	useHead({
		meta: [
			{ name: 'geo.placename', content: 'Freiberger Straße 18, 01067 Dresden, Germany'},
			{ name: 'geo.position', content: '51.049859,13.721999'},
			{ name: 'geo.region', content: 'DE-SN'},
			{ name: 'theme-color', content: '#F7A600'},
			{ name: 'msapplication-TileColor', content: '#F7A600'},
			{ property: 'og:type', content: 'website'},
			{ property: 'og:locale', content: 'de_DE'},
			{ name: 'seobility', content: '066b7225c5ae5f52ff57491170050ac6'}
		],
		link: [
			{ rel: 'icon', type: 'image/png', sizes: '16x16', content: usePublicUrl('/icons/favicon-16x16.png')},
			{ rel: 'icon', type: 'image/png', sizes: '32x32', content: usePublicUrl('/icons/favicon-32x32.png')},
			{ rel: 'icon', type: 'image/png', sizes: '192x192', content: usePublicUrl('/icons/android-chrome-192x192.png')},
			{ rel: 'icon', type: 'image/png', sizes: '512x512', content: usePublicUrl('/icons/android-chrome-512x512.png')},
			{ rel: 'apple-touch-icon', content: usePublicUrl('/icons/apple-touch-icon.png')},
			{ rel: 'msapplication-TileImage', content: usePublicUrl('/icons/tileImage-144x144.png')}
		]
	})

	const navigationItems = [
		{
			label: 'Angebote',
			title: 'Angebote der Cultus gGmbH',
			children: [
				{
					label: 'Menschen im Alter',
					name: 'article-detail',
					slug: 'hilfe-fuer-aeltere-menschen',
					title: 'Hilfe für ältere Menschen',
					icon: 'senioren',
					txtColorCls: 'text-stromboli-700',
					bgColorCls: 'bg-stromboli-700',
					borderColorCls: 'border-stromboli-700',
					hoverColorCls: 'hover:text-stromboli-700 hover:[&_span]:text-stromboli-700',
					children: [
						{
							label: 'Pflege- und Sozialberatung',
							name: 'article-detail',
							slug: 'pflege-und-sozialberatung',
							title: 'Pflege- und Sozialberatung'
						},
						{
							label: 'Ambulante Pflege',
							name: 'article-detail',
							slug: 'ambulante-pflege',
							title: 'Ambulante Pflege'
						},
						{
							label: 'Betreutes Wohnen',
							name: 'article-detail',
							slug: 'betreutes-wohnen',
							title: 'Betreutes Wohnen'
						},
						{
							label: 'Tagespflege',
							name: 'article-detail',
							slug: 'tagespflege',
							title: 'Tagespflege'
						},
						{
							label: 'Kurzzeitpflege',
							name: 'article-detail',
							slug: 'kurzzeitpflege',
							title: 'Kurzzeitpflege'
						},
						{
							label: 'Stationäre Pflege',
							name: 'article-detail',
							slug: 'stationaere-pflege',
							title: 'Stationäre Pflege'
						}
					]
				},
				{
					label: 'Menschen mit Behinderung',
					name: 'article-detail',
					slug: 'menschen-mit-behinderung',
					title: 'Menschen mit Behinderung',
					icon: 'behinderung',
					txtColorCls: 'text-blue-dianne-800',
					bgColorCls: 'bg-blue-dianne-800',
					borderColorCls: 'border-blue-dianne-800',
					hoverColorCls: 'hover:text-blue-dianne-800 hover:[&_span]:text-blue-dianne-800',
					children: [
						{
							label: 'Arbeitsangebote',
							name: 'article-detail',
							slug: 'arbeitsangebote-und-berufliche-bildung',
							title: 'Arbeitsangebote und Berufliche Bildung'
						},
						{
							label: 'Förder- und Betreuungsangebote',
							name: 'article-detail',
							slug: 'foerder-und-betreuungsangebote',
							title: 'Förder- und Betreuungsangebote'
						},
						{
							label: 'Wohnangebote',
							name: 'article-detail',
							slug: 'wohnangebote',
							title: 'Wohnangebote'
						},
						{
							label: 'Assistenzangebote',
							name: 'article-detail',
							slug: 'assistenzangebote',
							title: 'Assistenzangebote'
						},
						{
							label: 'Für Kunden / Auftraggeber',
							name: 'article-detail',
							slug: 'fuer-kunden-auftraggeber',
							title: 'Für Kunden / Auftraggeber'
						}
					]
				}
			]
		},
		{
			label: 'Standorte',
		 	name: 'location-list',
			title: 'Unsere Standorte'
		},
		{
			label: 'Aktuelles',
			name: 'news-list',
			title: 'Neuigkeiten'
		},
		{
			label: 'Karriere',
			name: 'article-detail',
			slug: 'karriere',
			title: 'Stellenangebote der Cultus gGmbH'
		},
		{
			label: 'Über uns',
			name: 'article-detail',
			slug: 'ueber-uns',
			title: 'Über die Cultus gGmbH der Landeshauptstadt Dresden'
		},
	]

	const importantFooterLinks = [
		{ label: 'Menschen im Alter', name: 'article-detail', slug: 'hilfe-fuer-aeltere-menschen', title: 'Hilfe für ältere Menschen'},
		{ label: 'Menschen mit Behinderung', name: 'article-detail', slug: 'menschen-mit-behinderung', title: 'Menschen mit Behinderung'},
		{ label: 'Standorte', name: 'location-list', title: 'Unsere Standorte'},
		{ label: 'Aktuelles', name: 'news-list', title: 'Neuigkeiten'},
		{ label: 'Speisepläne', name: 'article-detail', slug: 'aktuelle-speiseplaene', title: 'Aktuelle Speisepläne'},
		{ label: 'Karriere', name: 'article-detail', slug: 'karriere', title: 'Stellenangebote'},
	]

	const footerLinks = [
		{ label: 'Impressum', name: 'article-detail', slug: 'impressum', title: 'Anbieterkennzeichnung'},
		{ label: 'Datenschutz', name: 'article-detail', slug: 'datenschutzerklaerung', title: 'Datenschutzerklärung'},
		{ label: 'Hinweisgeberschutz', name: 'article-detail', slug: 'hinweisgeberschutzgesetz', title: 'Hinweisgeberschutz der Cultus gGmbH'},
		{ label: 'Barrierefreiheitserklärung', name: 'article-detail', slug: 'barrierefreiheitserklaerung', title: 'Barrierefreiheitserklärung'}
	]

	const socials = [
		{
			title: 'Instagram',
			icon: 'streamline:instagram',
			url: 'https://www.instagram.com/cultusggmbh/?hl=de'
		},
		{
			title: 'Facebook',
			icon: 'streamline:facebook-1',
			url: 'https://www.facebook.com/Cultus-gGmbH-der-Landeshauptstadt-Dresden-274945976188950/'
		},
		{
			title: 'LinkedIn',
			icon: 'streamline:linkedin',
			url: 'https://www.linkedin.com/company/cultus-ggmbh-dresden/'
		}
	]

	const header = ref(null)
	const isScrolled = ref<boolean>(false)

	const route = useRoute()
	const drawerOpen = ref(false)

	onMounted(() => {
		useEventListener(window, 'scroll', function(){
			isScrolled.value = window.scrollY > header.value.clientHeight
		})
	})

	watch(route, value => {
		if(drawerOpen.value) {
			drawerOpen.value = false
		}
  	}, {deep: true, immediate: true})
</script>

<template>
	<GsApp color-mode-preference="light">
		<NuxtLayout name="site-default">
			<template #header>
				<div ref="header" class="fluid relative pt-2 sm:pt-4 lg:pt-8 pb-2 sm:pb-4 transition duration-300 ease-in-out" :class="{'bg-white drop-shadow-xl sm:pt-2! lg:pt-4! sm:pb-2! z-max':isScrolled}">
					<div class="site-grid">
						<div class="flex justify-between">
							<div class="w-[120px] md:w-[160px] lg:w-[180px] xl:w-[200px] 2xl:w-[210px] my-auto pe-2 sm:pe-0" :class="{'md:!w-[110px] lg:!w-[135px]':isScrolled}">
								<NuxtLink :to="{name: 'home'}" class="block" title="zur Startseite">
									<img v-lazy-load  data-src="@/assets/img/cultus-dresden-logo.svg" alt="Logo der Cultus gGmbH der Landeshauptstadt Dresden" class="w-full" />
								</NuxtLink>
							</div>
							<div class="flex justify-end xl:justify-center xl:w-full">
								<Navigation v-if="$screen.gte.lg" :items="navigationItems" :isScrolled="isScrolled"></Navigation>
								<div v-if="$screen.lt.lg" class="flex-none">
									<UDrawer direction="left" v-model:open="drawerOpen" title="Navigation">
									 	<UButton :square="true" variant="solid" class="rounded-full p-3.5 bg-white/50 hover:bg-yellow-sea-500/25 cursor-pointer" title="Navigation öffnen" aria-label="Navigation öffnen">
											 <GsIcon name="fa6-solid:bars" class="size-7 text-woodsmoke-950"></GsIcon>
									 	</UButton>
									 	<template #header>
											<h2 class="sr-only">Navigation</h2>
										</template>
										<template #body>
											<NavigationMegaMobile :items="navigationItems" :footer-items="footerLinks.reverse()"></NavigationMegaMobile>
										</template>
									</UDrawer>
								</div>
							</div>
						</div>
					</div>
				</div>
			</template>

			<div class="relative">
				<NuxtPage/>
				<LayoutContactPopUp></LayoutContactPopUp>
			</div>

			<template #footer>
				<div class="w-full relative">
					<div class="h-auto lg:h-[880px] xl:h-[620px] w-full lg:w-[90%] 2xl:w-[95%] px-4 lg:px-8 pt-[52px] lg:pt-[100px] pb-[25px] bg-white rounded-tr-[80px] md:rounded-tr-[120px] xl:rounded-tr-[250px] 2xl:rounded-tr-[350px] shadow-[0px_0px_20px_0px_rgba(0,0,0,0.12)] inline-flex justify-center relative z-10">
						<div class="grid grid-cols gap-8">
							<div class="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-12 mb-16">
								<div>
									<span class="text-yellow-sea-500 font-light text-[20px] md:text-[22px] lg:text-[24px] xl:text-[28px] tracking-wide block mb-2">Wichtige Links</span>
									<nav v-if="importantFooterLinks?.length"  role="navigation" class="flex flex-col space-y-2">
										<NuxtLink v-for="(item,idx) in importantFooterLinks" :to="{name: item.name, params: item.slug ? { article_slug: item.slug } : {}}" no-prefetch class="text-woodsmoke-950 hover:text-yellow-sea-500 transition duration-300 ease-in-out" :title="item.label">{{ item.label }}</NuxtLink>
									</nav>
								</div>
								<div>
									<span class="text-yellow-sea-500 font-light text-[20px] md:text-[22px] lg:text-[24px] xl:text-[28px] tracking-wide leading-snug block mb-2">Cultus gGmbH der<br />Landeshauptstadt Dresden</span>
									<address class="text-woodsmoke-950 block mb-2 leading-10">
										Freiberger Straße 18<br />
										D-01067 Dresden
									</address>
									<a href="tel:+4903513138555" title="Nummer anrufen" class="text-woodsmoke-950 hover:text-yellow-sea-500 transition duration-300 ease-in-out block mb-2">Tel.: 0351 3138-555</a>
									<span class="text-woodsmoke-950 font-normal block">Fax: 0351 3138-418</span>
								</div>
								<div>
									<div v-if="socials?.length" class="flex flex-row gap-x-6 mb-16">
										<a v-for="social in socials" :href="social.url" :title="social.title" target="_blank" rel="nofollow" class="group">
											<GsIcon v-if="social.icon" :name="social.icon" class="flex-none text-black group-hover:text-yellow-sea-500 transition duration-300 ease-in-out size-8 lg:size-10 2xl:size-12" />
											<span class="sr-only" v-text="social.title"></span>
										</a>
									</div>
									<div>
										<img v-lazy-load  data-src="@/assets/img/stadtlogo-1200x300.jpg" alt="Unternehmen der Landeshauptstadt Dresden" class="w-full max-w-128" />
									</div>
								</div>
							</div>
							<div class="w-full mb-12">
								<nav v-if="footerLinks?.length"  role="navigation" class="flex flex-col md:flex-row justify-center md:justify-start space-x-6 md:space-x-12 space-y-4 md:space-y-0">
									<NuxtLink v-for="(item,idx) in footerLinks" :to="{name: item.name, params: item.slug ? { article_slug: item.slug } : {}}" no-prefetch class="text-woodsmoke-950 hover:text-yellow-sea-500 transition duration-300 ease-in-out" :title="item.label">{{ item.label }}</NuxtLink>
								</nav>
							</div>
							<div class="w-full flex justify-center md:justify-end">
								<a href="https://www.markov-markov.de" target="_blank" class="flex group xl:-mr-0">
									<span class="flex mx-auto xs:mx-none">
										<GsIcon name="fa:gears" class="flex-none text-[#cacaca] group-hover:text-stromboli-700 text-[14px] my-auto me-2 size-4 xl:size-5" />
										<span class="my-auto text-shooner-500 opacity-60 text-xl font-medium leading-9 group-hover:text-stromboli-700">markov&markov</span>
									</span>
								</a>
							</div>
						</div>
					</div>
					<div class="-z-5 absolute right-0 bottom-0 w-[620px] h-[620px] md:w-[720px] md:h-[720px] lg:w-[920px] lg:h-[1120px] xl:w-[1100px] xl:h-[1100px]">
						<div class="relative w-full h-full overflow-hidden">
							<LazyLayoutBkgCurvesBtm></LazyLayoutBkgCurvesBtm>
						</div>
					</div>
				</div>
			</template>
		</NuxtLayout>
	</GsApp>
</template>

<style>
	.site-grid {
		--padding-inline: theme('padding.4');
		--content-max-width: theme('screens.2xl');
		--breakout-max-width: 100%;
	}
	header {
		position: fixed;
		left: 0;
		top:0;
		width: 100%;
		z-index: 40;
	}
	header .router-link-active,
	nav .router-link-active {
		color: var(--color-yellow-sea-500);
	}
	.page-enter-active,
	.page-leave-active {
		transition: all 0.15s;
	}
	.page-enter-from,
	.page-leave-to {
		opacity: 0;
		transform: scale(0.9);
		filter: blur(.5rem);
	}
</style>
